export const APP_NAME = 'Skreeni';
export const roleTypes = [
  {
    id: 'TICKET_CHECKER',
    label: 'Ticket checker',
    helperText: 'Can scan tickets and get information about them',
  },
  {
    id: 'TICKET_INVALIDATOR',
    label: 'Ticket invalidator',
    helperText: 'Can verify tickets and mark them as used',
  },
  {
    id: 'EVENT_REPORTER',
    label: 'Event reporter',
    helperText: 'Can access the ticket sales data of the events',
  },
  {
    id: 'EVENT_CREATOR',
    label: 'Event creator',
    helperText: 'Can create the already configured events',
  },
  {
    id: 'EVENT_CONFIGURATOR',
    label: 'Event configurator',
    helperText: 'Can create and configure events',
  },
  {
    id: 'ORGANIZATION_ADMIN',
    label: 'Organization admin',
    helperText: 'Can manage user permissions and everything',
  },
];
interface Category {
  label: string;
  value: string;
}
export const eventCategories: Category[] = [
  { label: 'Film', value: 'FILM' },
  { label: 'Music', value: 'MUSIC' },
  { label: 'Exhibition', value: 'EXHIBITION' },
  { label: 'Experience', value: 'EXPERIENCE' },
  { label: 'Kids', value: 'KIDS' },
  { label: 'Sport', value: 'SPORT' },
  { label: 'Theater', value: 'THEATER' },
];
